module.exports = __webpack_public_path__ + "img/pdf3.a0527942.jpg";